@if (institutionId > 0) {
  <div id="submodule-events" class="cw-module-card">
    @if (!showEventDetails) {
      <div>
        <!-- Header -->
        <div class="cw-flex-row">
          <h2>{{ 'MODULES.INSTITUTIONS.EVENTS.TITLE' | translate }}</h2>
          <!-- Toolbar -->
          <phscw-toolbar
            componentIdentifier="institutions-events"
            [buttonAdd]="true"
            buttonAddTooltip="Erstellen"
            [buttonDelete]="allowDeleteEvents"
            buttonDeleteTooltip="Löschen"
            [buttonDeleteParameter]="{disabled: checkedEvents.length < 1}">
          </phscw-toolbar>
        </div>
        <!-- Grid um Events der Einrichtung anzuzeigen -->
        <phscw-grid
          #gridInstitutionsEvents
          gridId="institutionsEvents"
          [simpleGrid]="true"
          [gridData]="data"
          [gridColumns]="gridColumns"
          [gridDisplayedColumns]="gridDisplayedColumns">
        </phscw-grid>
      </div>
    }
    <!-- Event-Erfassung -->
    @if (showEventDetails) {
      <div>
        <phscw-event-form
          [institutionId]="institutionId"
          [institutionName]="selectedInstitutionName"
          [eventData]="selectedEventData"
          [editMode]="editAllowed"
          (submitEvent)="onEventSubmit($event)"
          (cancelEvent)="closeEventForm()">
        </phscw-event-form>
      </div>
    }
  </div>
}